import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PractitionerEdit } from 'src/app/shared/enums/practitioner-edit.enum';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';

@Component({
  selector: 'app-practitioner-edit',
  templateUrl: './practitioner-edit.component.html',
  styleUrls: ['./practitioner-edit.component.scss']
})
export class PractitionerEditComponent implements OnInit {
  practitionerProperty: PractitionerEdit;
  @Input() practitioner: Practitioner;
  @Output() updated = new EventEmitter<void>();
  @ViewChild('content') content: any;
  isLoading: boolean;

  get practitionerEditEnum(): typeof PractitionerEdit {
    return PractitionerEdit;
  }

  constructor(private modalService: NgbModal, private practitionerService: PractitionerService) { }

  ngOnInit(): void {

  }

  onSubmit(formGroup: FormGroup): void {
    let updates: Object = this.createUpdateProperties(formGroup);
    if (!Object.keys(updates).length) { return; }
    this.isLoading = true;
    this.practitionerService.updatePractitioner(this.practitioner, updates).then(_ => {
      this.isLoading = false;
      this.updated.emit();
      this.modalService.dismissAll();
    }, error => {
      this.isLoading = false;
      console.log(error);
      alert(error);
    });
  }

  createUpdateProperties(form: FormGroup): Object {
    let updates: any = {};
    Object.keys(form.controls).forEach(key => {
      let currentControl = form.controls[key];
      if (currentControl.dirty) {
        updates[key] = currentControl.value;
      }
    })
    return updates;
  }

  open(propertyToEdit: PractitionerEdit) {
    this.practitionerProperty = propertyToEdit;
    this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title', scrollable: true, backdrop: 'static', size: 'xl' });
  }
}
